import { CRM_PRODUCT_ID, DEV_PRODUCT_ID } from "constants/products";

export const cookieValues = {
  [CRM_PRODUCT_ID]: {
    key: "crm_big_signup_modal_for_products_ab_test",
    value: "new_with_big_signup_modal_for_products"
  },

  [DEV_PRODUCT_ID]: {
    key: "dev_big_signup_modal_for_products_ab_test",
    value: "new_with_big_signup_modal_for_products"
  }
};
